// Brazilian first names
export const firstNames = [
  'João', 'Maria', 'José', 'Ana', 'Pedro', 'Paula', 'Carlos', 'Mariana',
  'Lucas', 'Julia', 'Gabriel', 'Beatriz', 'Rafael', 'Fernanda', 'Bruno',
  'Camila', 'Felipe', 'Larissa', 'Leonardo', 'Amanda', 'Gustavo', 'Leticia',
  'Rodrigo', 'Patricia', 'Diego', 'Aline', 'Thiago', 'Isabela', 'Marcelo',
  'Rafaela', 'André', 'Carolina', 'Fernando', 'Gabriela', 'Ricardo', 'Daniela',
  'Eduardo', 'Vanessa', 'Matheus', 'Juliana', 'Henrique', 'Priscila', 'Vitor',
  'Natalia', 'Caio', 'Barbara', 'Daniel', 'Renata', 'Miguel', 'Laura'
];

// Brazilian last names
export const lastNames = [
  'Silva', 'Santos', 'Oliveira', 'Souza', 'Rodrigues', 'Ferreira', 'Alves',
  'Pereira', 'Lima', 'Gomes', 'Costa', 'Ribeiro', 'Martins', 'Carvalho',
  'Almeida', 'Lopes', 'Soares', 'Fernandes', 'Vieira', 'Barbosa', 'Rocha',
  'Dias', 'Nascimento', 'Andrade', 'Moreira', 'Nunes', 'Marques', 'Machado',
  'Mendes', 'Freitas', 'Cardoso', 'Ramos', 'Gonçalves', 'Santana', 'Teixeira',
  'Moraes', 'Araujo', 'Correia', 'Melo', 'Barros', 'Castro', 'Monteiro',
  'Pinto', 'Campos', 'Cunha', 'Reis', 'Azevedo', 'Batista', 'Borges', 'Miranda'
];

// Brazilian states with their codes (filtered list)
export const brazilianStates = [
  { uf: 'random', name: 'Estado Aleatório', emoji: '🎲' },
  { uf: 'AL', name: 'Alagoas' },
  { uf: 'BA', name: 'Bahia' },
  { uf: 'CE', name: 'Ceará' },
  { uf: 'DF', name: 'Distrito Federal' },
  { uf: 'ES', name: 'Espírito Santo' },
  { uf: 'MS', name: 'Mato Grosso do Sul' },
  { uf: 'MG', name: 'Minas Gerais' },
  { uf: 'PB', name: 'Paraíba' },
  { uf: 'PR', name: 'Paraná' },
  { uf: 'PE', name: 'Pernambuco' },
  { uf: 'PI', name: 'Piauí' },
  { uf: 'RN', name: 'Rio Grande do Norte' },
  { uf: 'RS', name: 'Rio Grande do Sul' },
  { uf: 'SC', name: 'Santa Catarina' },
  { uf: 'SE', name: 'Sergipe' }
];

// List of actual states (without the random option)
export const actualStates = brazilianStates.filter(s => s.uf !== 'random');

// Track last used state to avoid repetition
let lastUsedState = null;

// Get a random state, avoiding the last used one if possible
export function getRandomState() {
  const availableStates = actualStates.filter(s => s.uf !== lastUsedState);
  const statesList = availableStates.length > 0 ? availableStates : actualStates;
  const randomState = statesList[Math.floor(Math.random() * statesList.length)];
  lastUsedState = randomState.uf;
  return randomState.uf;
}

// Cities list by state for dropdown
export const citiesByState = {
  AL: [
    { name: 'Maceió' },
    { name: 'Arapiraca' },
    { name: 'Rio Largo' },
    { name: 'Palmeira dos Índios' }
  ],
  BA: [
    { name: 'Salvador' },
    { name: 'Feira de Santana' },
    { name: 'Vitória da Conquista' },
    { name: 'Camaçari' }
  ],
  CE: [
    { name: 'Fortaleza' },
    { name: 'Caucaia' },
    { name: 'Juazeiro do Norte' },
    { name: 'Maracanaú' }
  ],
  DF: [
    { name: 'Brasília' }
  ],
  ES: [
    { name: 'Vitória' },
    { name: 'Vila Velha' },
    { name: 'Serra' },
    { name: 'Cariacica' }
  ],
  MS: [
    { name: 'Campo Grande' },
    { name: 'Dourados' },
    { name: 'Três Lagoas' },
    { name: 'Corumbá' }
  ],
  MG: [
    { name: 'Belo Horizonte' },
    { name: 'Uberlândia' },
    { name: 'Contagem' },
    { name: 'Juiz de Fora' },
    { name: 'Betim' }
  ],
  PB: [
    { name: 'João Pessoa' },
    { name: 'Campina Grande' },
    { name: 'Santa Rita' },
    { name: 'Patos' }
  ],
  PR: [
    { name: 'Curitiba' },
    { name: 'Londrina' },
    { name: 'Maringá' },
    { name: 'Ponta Grossa' },
    { name: 'Cascavel' }
  ],
  PE: [
    { name: 'Recife' },
    { name: 'Jaboatão dos Guararapes' },
    { name: 'Olinda' },
    { name: 'Caruaru' },
    { name: 'Petrolina' }
  ],
  PI: [
    { name: 'Teresina' },
    { name: 'Parnaíba' },
    { name: 'Picos' }
  ],
  RN: [
    { name: 'Natal' },
    { name: 'Mossoró' },
    { name: 'Parnamirim' },
    { name: 'São Gonçalo do Amarante' }
  ],
  RS: [
    { name: 'Porto Alegre' },
    { name: 'Caxias do Sul' },
    { name: 'Pelotas' },
    { name: 'Canoas' },
    { name: 'Santa Maria' }
  ],
  SC: [
    { name: 'Florianópolis' },
    { name: 'Joinville' },
    { name: 'Blumenau' },
    { name: 'São José' },
    { name: 'Chapecó' }
  ],
  SE: [
    { name: 'Aracaju' },
    { name: 'Nossa Senhora do Socorro' },
    { name: 'Lagarto' },
    { name: 'Itabaiana' }
  ]
};

// Get cities for a specific state
export function getCitiesForState(uf) {
  return citiesByState[uf] || [];
}

// Phone area codes by state (filtered list)
export const areaCodes = {
  AL: ['82'],
  BA: ['71', '73', '74', '75', '77'],
  CE: ['85', '88'],
  DF: ['61'],
  ES: ['27', '28'],
  MS: ['67'],
  MG: ['31', '32', '33', '34', '35', '37', '38'],
  PB: ['83'],
  PR: ['41', '42', '43', '44', '45', '46'],
  PE: ['81', '87'],
  PI: ['86', '89'],
  RN: ['84'],
  RS: ['51', '53', '54', '55'],
  SC: ['47', '48', '49'],
  SE: ['79']
};

// Generate a random full name
export function generateFullName() {
  const firstName = firstNames[Math.floor(Math.random() * firstNames.length)];
  const lastName1 = lastNames[Math.floor(Math.random() * lastNames.length)];
  const lastName2 = lastNames[Math.floor(Math.random() * lastNames.length)];
  return `${firstName} ${lastName1} ${lastName2}`;
}

// Generate a valid CPF
export function generateCPF() {
  const randomDigits = () => Math.floor(Math.random() * 10);
  
  // Generate first 9 digits
  const digits = [];
  for (let i = 0; i < 9; i++) {
    digits.push(randomDigits());
  }
  
  // Calculate first verification digit
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += digits[i] * (10 - i);
  }
  let remainder = sum % 11;
  const digit1 = remainder < 2 ? 0 : 11 - remainder;
  digits.push(digit1);
  
  // Calculate second verification digit
  sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += digits[i] * (11 - i);
  }
  remainder = sum % 11;
  const digit2 = remainder < 2 ? 0 : 11 - remainder;
  digits.push(digit2);
  
  // Format CPF: XXX.XXX.XXX-XX
  const cpf = digits.join('');
  return `${cpf.slice(0, 3)}.${cpf.slice(3, 6)}.${cpf.slice(6, 9)}-${cpf.slice(9, 11)}`;
}

// Generate a valid Brazilian phone number
export function generatePhone(uf) {
  const codes = areaCodes[uf];
  if (!codes || codes.length === 0) {
    return null;
  }
  
  const areaCode = codes[Math.floor(Math.random() * codes.length)];
  // Brazilian mobile phones start with 9 and have 9 digits
  const firstDigit = '9';
  const remainingDigits = String(Math.floor(Math.random() * 100000000)).padStart(8, '0');
  
  return `(${areaCode}) ${firstDigit}${remainingDigits.slice(0, 4)}-${remainingDigits.slice(4, 8)}`;
}

// Fallback: Fetch address from ViaCEP API (used only if local base fails)
export async function fetchAddressByCEP(cep) {
  const cleanCep = cep.replace(/\D/g, '');
  
  try {
    const response = await fetch(`https://viacep.com.br/ws/${cleanCep}/json/`);
    const data = await response.json();
    
    if (data.erro) {
      return { error: true, message: 'CEP não encontrado' };
    }
    
    const isComplete = data.logradouro && data.logradouro.trim() !== '' &&
                       data.bairro && data.bairro.trim() !== '' &&
                       data.localidade && data.localidade.trim() !== '' &&
                       data.uf && data.uf.trim() !== '';
    
    if (!isComplete) {
      return { error: true, message: 'CEP com endereço incompleto', incomplete: true };
    }
    
    return {
      error: false,
      logradouro: data.logradouro,
      bairro: data.bairro,
      cidade: data.localidade,
      estado: data.uf
    };
  } catch (error) {
    return { error: true, message: 'Erro ao consultar CEP' };
  }
}

// Format CEP: 12345678 -> 12345-678
export function formatCep(cep) {
  const clean = String(cep).replace(/\D/g, '');
  return `${clean.slice(0, 5)}-${clean.slice(5)}`;
}
